<script setup lang="ts">
import { DSButton } from '@ds'
import { RotateCwIcon } from '@lucide/vue'

type Props = {
  isShrunk?: boolean
}

defineProps<Props>()
</script>

<template>
  <DSButton
    variant="ghost"
    :size="isShrunk ? 'icon' : 'sm'"
    class="shrink-0"
  >
    <RotateCwIcon
      :class="isShrunk ? 'size-4.5!' : 'size-3.5!'"
      aria-hidden="true"
    />
    <span v-if="!isShrunk">Refresh analytics</span>
  </DSButton>
</template>
